export interface EmailInput {
  email: string;
}

export interface OtpInput {
  otp_id: string;
  code: string;
  mail_subscriptions_allowed: boolean;
}

export type SetUserEmailInput = EmailInput | OtpInput;

export function isOtpInput(input: SetUserEmailInput): input is OtpInput {
  return (input as OtpInput).otp_id !== undefined;
}
